module.exports = __webpack_public_path__ + "img/visa.3b66a3b1.svg";